<div class="page-content">
	<app-scroll-into-view class="scroll-into-view" [id]="pageName"></app-scroll-into-view>
	
	<!-- <app-search-content [displayPage]="true" ></app-search-content> -->

	<app-data 
		[displayPage]="true"
		[dataSource]="{storeName: pageName, id: '', static: false}"
	>
		<ng-template 
			#optionTemplate 
			let-articles$="articles$"
			let-count$="count$" 
			let-status$="status$"
			let-pageParams$="pageParams$"
			let-displayPage="displayPage"
			let-scrollInToView$="scrollInToView$"
			let-pager$="pager$"
		>
			<app-loader class="loader" [status$]="status$"></app-loader>
			
			<app-search-bar 
				[count$]="count$"
				[status$]="status$" 
				[articles$]="articles$" 
				[pageParams$]="pageParams$"
				[pageName]="pageName"
				[scrollInToView$]="scrollInToView$"
				[class]="class"						
			></app-search-bar>

			<app-grid 
				[articles$]="articles$" 
				[displayPage]="displayPage" 
				[queryParams$]="queryParams$"
			></app-grid>

			<app-pager 
				[status$]="status$"
				[pager$]="pager$" 
			></app-pager>
				
		</ng-template>
	</app-data>

</div>

<app-page-bottom></app-page-bottom>
